import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["saveButton"];

  connect() {
    $(this.element)
      .find("select.search-select-input")
      .on("select2:select select2:unselect select2:clear", function () {
        this.dispatchEvent(new Event("change", { bubbles: true }));
      });

    // The form's Stimulus `change->` action only sees native events, but select2
    // fires a jQuery change on the hidden original select. Binding through
    // jQuery catches both, so every dropdown reveals the save button — delegated
    // so selects added after connect() are covered too.
    $(this.element).on("change.articleEditForm", "select", () => this.reveal());
  }

  disconnect() {
    $(this.element).off("change.articleEditForm");
  }

  reveal() {
    this.saveButtonTarget.style.display = "";
  }
}
